e360.service('orgsApi', ['$http', 'apiHelper', function ($http, apiHelper) {
   return {
      get: function (id) {
         return apiHelper.get('orgs/' + id);
      },
      create: function (org) {
         return apiHelper.post('orgs', org);
      },
      update: function (org) {
         // In case the org object is sent with brands hydrated, we should remove the property since
         // the server will throw an exception when it receives it.
         // TODO: Better validation on the backend
         var orgCopy = angular.copy(org);
         delete orgCopy.brands;

         return apiHelper.post('orgs/' + orgCopy.id, orgCopy);
      },
      del: function (id) {
         return apiHelper.del('orgs/' + id);
      }
   };
}]);
